import { call, fork, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';

import history from '../history';
import * as types from '../constants/actionTypes';
import actions from '../actions';
import api from '../lib/api';
import notify from '../lib/notify';

export function* createDriverRatingSaga(options) {
  try {
    yield put(actions.form.createDriverRatingLoading());
    const data = yield call(api.rating.create, options.data, options.formType);
    yield put(actions.form.createDriverRatingSuccess(data));
    if (!_.includes(options.formType, ['on', 'off'])) {
      yield put(actions.form.removeNonHeaderFields('rating'));
    }
    history.push(options.redirectTo || '/confirmation/rating');
    window.scrollTo(0, 0);
  } catch (e) {
    yield put(actions.form.createDriverRatingError());
    yield call(notify, e);
  }
}

export function* fetchDriverRatingOptionsSaga(options) {
  try {
    yield put(actions.ui.setRatingType('rating'));
    yield put(actions.form.fetchDriverRatingOptionsLoading());
    const data = yield call(api.rating.options, options.formType);
    yield put(actions.form.fetchDriverRatingOptionsSuccess(data));
    yield put(actions.validation.updateRules('rating', data));
  } catch (e) {
    yield put(actions.form.fetchDriverRatingOptionsError());
    yield call(notify, e);
  }
}

export function* watchCreateDriverRatingSaga() {
  yield takeLatest(types.CREATE_DRIVER_RATING, createDriverRatingSaga);
}

export function* watchFetchDriverRatingOptionsSaga() {
  yield takeLatest(types.FETCH_DRIVER_RATING_OPTIONS, fetchDriverRatingOptionsSaga);
}

export default [
  fork(watchCreateDriverRatingSaga),
  fork(watchFetchDriverRatingOptionsSaga),
];
